import { API } from "../api/API";

export const postRefreshLogin = async (loginData) => {
  const result = await API()
    .post("user/token/refresh", loginData)
    .catch((error) => {
      return error.response ? error.response : { error };
    });
  return result;
};

export const getVerifyToken = async (token) => {
  const result = await API()
    .get("academy/user/verify")
    .catch(() => {
      return false;
    });
  if (result.status === 200) {
    return true;
  } else {
    return false;
  }
};
